// extracted by mini-css-extract-plugin
module.exports = {"bonus":"_11229","text":"_9078","icon":"_16027"};